<template>
    <transition :name="disableTransitions ? '' : 'el-zoom-in-center'">
        <span class="vue-tag" :class="[type ? 'vue-tag_' + type : '', tagSize && `vue-tag_${tagSize}`, {'is-hit': hit}]" :style="{backgroundColor: color}">
          <i class="vue-tag__icon" :class="icon" v-if="icon"></i>
          <slot></slot>
          <i class="vue-tag__close fa fa-times" v-if="closable" @click.stop="handleClose"></i>
        </span>
    </transition>
</template>
<script>
    export default {
        name: 'vueTag',
        props: {
            icon: {
                type: String,
                default: ''
            },
            text: String,
            closable: Boolean,
            type: String,
            hit: Boolean,
            disableTransitions: Boolean,
            color: String,
            size: String
        },
        methods: {
            handleClose(event) {
                this.$emit('close', event);
            }
        },
        computed: {
            tagSize() {
                return this.size || (this.$ELEMENT || {}).size;
            }
        }
    };
</script>
